import React, { useState } from "react";
import classes from "./More.module.css";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import products from "../../products/products";
import translate from "../../service/Language";
import Currecy from "../../service/Currency";
import { toast } from "react-toastify";
import "./More.css"

function More({ cartNumbers,
  setCheckout,
  setOneClick,
  setOneClickProduct, setToggle }) {
  const Products = products[window.location.pathname.split("/").pop()];

  if (!Products) {
    window.location.href = "/";
  }

  document.title = `${Products.title_uz} | ${Products.title_ru}`

  const [activePhoto, setActivePhoto] = useState(Products.images[0].img);
  return (
    <div className={classes.More}>
      <div className={classes.Left}>
        <div className={classes.more_images}>
          {Products.images
            ? Products.images.map((item, index) => (
              <img
                key={index}
                src={item.img}
                alt=""
                onClick={(e) => {
                  setActivePhoto(item.img);
                }}
              />
            ))
            : ""}
        </div>
        <div className={classes.active_image}>
          <TransformWrapper>
            <TransformComponent>
              <img src={activePhoto} alt="" />
            </TransformComponent>
          </TransformWrapper>
        </div>
      </div>
      <div className={classes.Right}>
        <h2>{translate(Products.title_ru, Products.title_uz)}</h2>
        <h3>
          {translate("Цена: ", "Narxi: ")} <p> {Currecy(Products.price)} UZS</p>
        </h3>
        {Products.oldPrice ? <h4> {Currecy(Products.oldPrice)} UZS</h4> : ""}
        <p className={classes.desc}>
          {translate(Products.desc_ru, Products.desc_uz)}
        </p>
        <div className={classes.buttons}>
          <button className={classes.add_toCart} onClick={(e) => {
            cartNumbers(Products);
            toast.success(translate("Добавлен!", "Qo'shildi!"))
          }}>
            {translate("Добавить в корзину", "Savatga qo'shish")}
          </button>
          <button className={classes.buy} onClick={(e) => {
            setOneClick(Products.price)

            setOneClickProduct(Products.title_uz)
            setCheckout(true);
          }}>
            {translate("Купить в 1 клик", "Tugmani 1 bosishda xarid qilish")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default More;
